export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '姓名',
		align: 'center',
		dataIndex: 'name',
	},
	{
		title: '电话号码',
		align: 'center',
		dataIndex: 'mobile',
	},
	{
		title: '所属律所',
		align: 'center',
		dataIndex: 'lawOffice',
	},
	{
		title: '执业地区',
		align: 'center',
		dataIndex: 'fullDesc',
	},
	{
		title: '接单数量',
		align: 'center',
		dataIndex: 'finishCount',
	},
	{
		title: '综合评分',
		align: 'center',
		dataIndex: 'score',
	},
	{
		title: '账号状态',
		align: 'center',
		dataIndex: 'status',
		scopedSlots: { customRender: 'status' },
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
